import { useState } from "react";

const EMPTY = {
  startDate: "",
  endDate: "",
  category: "",
  description: "",
  minAmount: "",
  maxAmount: "",
  paymentType: "",
};

export function useTableView({
  dateField = "date",
  categoryField = "category",
  descField = "description",
  amountField = "amount",
  paymentTypeField = "payment_type",
} = {}) {
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const [filters, setFilters] = useState(EMPTY);

  const toggleSort = (key) => {
    if (sortKey !== key) {
      setSortKey(key);
      setSortDir("asc");
      return;
    }
    if (sortDir === "asc") setSortDir("desc");
    else {
      setSortKey(null);
      setSortDir("asc");
    }
  };

  const resetFilters = () => setFilters(EMPTY);

  const apply = (rows) => {
    let out = (rows || []).filter((r) => {
      const d = r[dateField] || "";
      if (filters.startDate && d < filters.startDate) return false;
      if (filters.endDate && d > filters.endDate) return false;
      if (
        filters.category &&
        !String(r[categoryField] || "")
          .toLowerCase()
          .includes(filters.category.toLowerCase())
      )
        return false;
      if (
        filters.description &&
        !String(r[descField] || "")
          .toLowerCase()
          .includes(filters.description.toLowerCase())
      )
        return false;
      const amt = Number(r[amountField] || 0);
      if (filters.minAmount !== "" && amt < Number(filters.minAmount)) return false;
      if (filters.maxAmount !== "" && amt > Number(filters.maxAmount)) return false;
      if (filters.paymentType && (r[paymentTypeField] || "resmi") !== filters.paymentType) return false;
      return true;
    });
    if (sortKey) {
      out = [...out].sort((a, b) => {
        const av = a[sortKey];
        const bv = b[sortKey];
        if (av == null && bv == null) return 0;
        if (av == null) return 1;
        if (bv == null) return -1;
        if (typeof av === "number" && typeof bv === "number") {
          return sortDir === "asc" ? av - bv : bv - av;
        }
        return sortDir === "asc"
          ? String(av).localeCompare(String(bv), "tr")
          : String(bv).localeCompare(String(av), "tr");
      });
    }
    return out;
  };

  return { sortKey, sortDir, toggleSort, filters, setFilters, resetFilters, apply };
}
